import { AutoComplete, Input } from 'antd'
import { graphql, useStaticQuery, navigate } from 'gatsby'
import React from 'react'

import { PRODUCT_NAME } from './constants'

const kbSearchQuery = graphql`
  query kbSearch {
    allSanityArticle {
      edges {
        node {
          name
          products
          slug {
            current
          }
        }
      }
    }
  }
`

export function KnowledgeBaseSearch() {
  const data = useStaticQuery(kbSearchQuery)
  const [options, setOptions] = React.useState([])
  const allOptions = data.allSanityArticle.edges
    .filter(edge => edge.node.products.includes(PRODUCT_NAME))
    .map(edge => ({
      value: edge.node.slug.current,
      label: edge.node.name,
    }))
  return (
    <AutoComplete
      options={options}
      onSearch={value => {
        setOptions(allOptions.filter(opt => opt.label.toLowerCase().includes(value.toLowerCase())))
      }}
      onSelect={(_, option) => {
        navigate(option.value)
      }}
      style={{ width: '100%' }}
    >
      <Input.Search placeholder={'Search the Knowledge Base...'} size={'large'} />
    </AutoComplete>
  )
}
